import React from 'react';
import { Table, Modal } from 'react-bootstrap';

export default function ModalProdutosPesquisa(props) {
  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      scrollable
    >
      <Modal.Header closeButton>
        <Modal.Title>Produtos</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0">
        <div className="dash-table-titulo rounded-0">
          <span className="pl-3">Produtos mais vendidos na loja</span>
        </div>
        <Table className="dash-table" responsive variant="dark">
          <thead className="dash-table-header">
            <tr>
              <th>Marca</th>
              <th>Produto</th>
              <th>Qtde</th>
              <th>Valor Unitário</th>
            </tr>
          </thead>
          <tbody className="dash-table-body">
            {props.produtos.map((produto) => (
              <tr key={produto.produto}>
                <td>{produto.marca}</td>
                <td>{produto.produto}</td>
                <td>{Number(produto.qtde).toLocaleString('pt-BR')}</td>
                <td>
                  {Number(produto.valorUnitario)
                    .toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                    })
                    .toString()
                    .replace(/\u00a0/g, ' ')}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <div className="dash-table-titulo rounded-0">
          <span className="pl-3">Produtos por marca</span>
        </div>
        <Table className="dash-table" responsive variant="dark">
          <thead className="dash-table-header">
            <tr>
              <th>Marca</th>
              <th>Produto</th>
              <th>Qtde</th>
              <th>Valor Unitário</th>
            </tr>
          </thead>
          <tbody className="dash-table-body">
            {props.concorrente.map((produto) => (
              <tr key={produto.produto}>
                <td>{produto.marca}</td>
                <td>{produto.produto}</td>
                <td>{Number(produto.qtde).toLocaleString('pt-BR')}</td>
                <td>
                  {Number(produto.valorUnitario)
                    .toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                    })
                    .toString()
                    .replace(/\u00a0/g, ' ')}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Modal.Body>
    </Modal>
  );
}
